import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DialogActionsDirective } from './dialog-actions.directive';
import { DialogContentDirective } from './dialog-content.directive';
import { DialogTitleDirective } from './dialog-title.directive';

@NgModule({
  imports: [CommonModule, OverlayModule, PortalModule, DialogTitleDirective, DialogContentDirective, DialogActionsDirective],
  exports: [DialogTitleDirective, DialogContentDirective, DialogActionsDirective],
})
export class DialogModule {}
